import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./static/fonts/Pretendard/pretendard.css";
import "./static/fonts/NotoSans/notosans.css";
import "./static/fonts/AppleGothicNeo/applegothic.css";
import "./static/fonts/Nanum/nanum.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
